import React from 'react';
import TextInput, {
  filterNumericKeyPress,
} from '../../../components/TextInput';

export default function LeadsPersonalInfoView(props) {
  return (
    <>
      <TextInput
        name="ssn"
        label="Last 4 Digits of your SIN"
        validationData={props.validations}
        formData={props.formData}
        onChange={props.onChange}
        type="text"
        pattern="[0-9]{4}"
        maxLength="4"
        helpText="####"
        required
        onKeyPress={filterNumericKeyPress}
      />
      <TextInput
        name="birthday"
        label="Birthday"
        validationData={props.validations}
        formData={props.formData}
        onChange={props.onChange}
        type="text"
        pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
        maxLength="10"
        minLength="10"
        helpText="YYYY-MM-DD"
        required
      />
    </>
  );
}
